export default "/packs/images/snow-1~f36be11c7e19abc6c02399318b1c73f1.png";